export interface IAnnotationSearchableLink {
    id: string;
    searchModalities: ISearchModalityMap;
    classes: Array<string>;
}

export interface ISearchModalityMap {
    snv?: IModalitySearch;
    fusion?: IModalitySearch;
    cnv?: IModalitySearch;
}

export interface IModalitySearch {
    label?: string;
    labelHtml?: string;
    searchTemplate: string;
    sources: Array<IModalitySource>;

}

export interface IModalitySource {
    // first?: Array<ISearchSource>;
    all?: Array<ISearchSource>;
    // default?: Array<ISearchSource>;
}

export interface ISearchSource {
    source: SearchSource | string;
    key: string;
    staticValue?: string;
    field?: string;
    sourceKey?: string;
}

export class SearchSource {
    static STORE_AC_SERVICE = 'storeService';
    static DIAGNOSTIC_ORDER = 'diagnosticOrder';
    static CURRENT_WORKFLOW = 'workflow';
    static ARGS = 'args';
}
